import api from '@/store/api/customer/product/number/billings'
import * as mutationTypes from './mutation-types'
import {mapLegacyPagination} from '@/store/utils'

// Modules
import billing from './billing'

const initialState = () => ({
    billings: {
        data: [],
        pagination: {}
    }
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        billings: state => state.billings.data,
        pagination: state => state.billings.pagination
    },
    actions: {
        listBillings: async ({commit, dispatch}, data) => {
            try {
                const response = await api.listBillings(data)
                const billings = {
                    ...response,
                    pagination: mapLegacyPagination(response.pagination)
                }
                commit(mutationTypes.SET_NUMBER_BILLINGS, billings)
                return billings
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetBilling: async ({commit}) => commit(mutationTypes.RESET_NUMBER_BILLINGS)
    },
    modules: {
        billing
    },
    mutations: {
        [mutationTypes.SET_NUMBER_BILLINGS]: (state, data) => state.billings = data,
        [mutationTypes.RESET_NUMBER_BILLINGS]: (state) => Object.assign(state, initialState())
    }
}
